export const radiatorTypes = Object.freeze({
  PP: 'PP',
  GS: 'GS',
  HW: 'HW',
  GG: 'GG',
  GR: 'GR',
  PG: 'PG',
  UNKNOWN: 'UNKNOWN',
  PlaceholderRadiator: 'PlaceholderRadiator',
});

export type RadioOption = {
  name: string;
  value: any;
  subtitle?: string;
  image?: string;
  icon?: string;
};

type radiatorFormType = {
  [key: string]: RadioOption;
};

export const radiatorFormTypes: radiatorFormType = Object.freeze({
  PP: {
    name: 'PP',
    subtitle: 'Profilierte Platte',
    value: 'PP',
    image: new URL('@/assets/img/radiators/PP/PP.svg', import.meta.url).href,
  },
  GS: {
    name: 'GS',
    subtitle: 'Gliederheizkörper aus Stahl',
    value: 'GS',
    image: new URL('@/assets/img/radiators/GS/GS.svg', import.meta.url).href,
  },
  HW: {
    name: 'HW',
    subtitle: 'Handtuchwärmekörper',
    value: 'HW',
    image: new URL('@/assets/img/radiators/HW/HW.svg', import.meta.url).href,
  },
  GG: {
    name: 'GG',
    subtitle: 'Gliederheizkörper aus Guss',
    value: 'GG',
    image: new URL('@/assets/img/radiators/GG/GG.svg', import.meta.url).href,
  },
  GR: {
    name: 'GR',
    subtitle: 'Gliederheizkörper aus Rohren',
    value: 'GR',
    image: new URL('@/assets/img/radiators/GR/GR.svg', import.meta.url).href,
  },
  PG: {
    name: 'PG',
    subtitle: 'Glatter Plattenheizkörper',
    value: 'PG',
    image: new URL(
      '@/assets/img/radiators/PG/PG_with_cover.svg',
      import.meta.url
    ).href,
  },
  UNKNOWN: {
    name: 'Unbekannt',
    subtitle: 'Heizkörper passt zu keinem der Typen',
    value: 'UNKNOWN',
    image: new URL('@/assets/img/radiators/unknown.svg', import.meta.url).href,
  },
  PlaceholderRadiator: {
    name: 'Heizkörper',
    subtitle: '',
    value: 'PlaceholderRadiator',
    image: '',
  },
});
